<template lang="pug">
  .main-wrap.main-header(data-track="Main Header" :class="{'fixed-header': isGymMap}")
    .main.main-container-wide
      .hamburger
        .box
        .box
        .box
      rogue-link.logo-wrap(to="/" aria-label="Link to Homepage")
        img.header-logo(src='@/assets/rogue-logo.svg' :alt="$rogue.site.name" width="275" height="43")
      .middle
        search
        deals
      .chat-widget(v-if="hasLiveChat")
        live-chat.chat-mobile
      .acct
        account
</template>
<script setup lang="ts">
import { computed, defineAsyncComponent } from 'vue'
import { useRoute } from 'vue-router'
import Search from '@/js/components/header/search/search.vue'
import Account from '@/js/components/header/account.vue'
import { useLiveChat } from '@/js/composables/useLiveChat'

const route = useRoute()
const { hasLiveChat } = useLiveChat()

const neverHydrate = () => {}

const Deals = defineAsyncComponent({
  loader  : () => import(/* webpackChunkName: "ssr-header-static"*/ '@/js/components/header/deals.vue'),
  hydrate : neverHydrate,
})

// Gym map page fills entire mobile screen, so we don't want the headers to move when you scroll
const isGymMap = computed<boolean>(() => {
  return route.path.indexOf('/rogue-equipped-gyms') !== -1
})
</script>
<style lang="scss" scoped>

$mobile-row-height: 51px;
$mobile-search-height: 53px;

$tablet-height: 53px;

.main-wrap {
  background-color: $color-black;
}

.logo-wrap {
  display: inline-block;
  height: $mobile-row-height;
  overflow: hidden;

  @include not-desktop() {
    margin-left: 74px;
  }
}

.header-logo {
  width: 122px;
  height: 100%;

  @include all-desktop() {
    width: 206px;
  }
}

.hamburger {
  position: absolute;
  top: 0;
  left: 0;
  height: $mobile-row-height;
  background-color: $color-red;
  width: 58px;
  cursor: pointer;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding: $space-s;

  .box {
    background-color: white;
    height: 3px;
    pointer-events: none;
  }

  @include tablet() {
    height: $tablet-height;
  }

  @include all-desktop() {
    display: none;
  }
}

.main {
  color: $color-white;
  position: relative;

  @include mobile() {
    margin: 0;
  }

  @include not-mobile() {
    display: flex;
    padding: $space-xxs;
    align-items: center;
    justify-content: space-between;

    .middle {
      display: flex;
      align-items: center;
      flex-grow: 1;
      max-width: 1000px;
    }
  }

  @include tablet() {
    height: $tablet-height;
    margin: 0;
  }

  @include all-desktop() {
    padding: 0;
    height: 110px;
  }
}

.chat-widget {
  @include mobile() {
    position: absolute;
    display: flex;
    align-items: center;
    top: 0;
    height: $mobile-row-height;
    right: 87px;
  }
  @include tablet() {
    right: 92px;
  }
  @include all-desktop() {
    display: none;
  }
}

.acct {
  @include mobile() {
    position: absolute;
    display: flex;
    align-items: center;
    top: 0;
    height: $mobile-row-height;
    right: $space-s;
  }
  @include not-mobile() {
    margin-right: $space-xs;
  }
}

.fixed-header {
  .middle {
    @include mobile() {
      display: none;
    }

    @include tablet() {
      visibility: hidden;
    }
  }

  @include not-desktop() {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
  }
}

</style>
